(() => {
  // Mobile menu drawer
  const drawer = document.getElementById('drawer');
  const toggle = (open) => {
    if (!drawer) return;
    drawer.hidden = !open;
    document.body.style.overflow = open ? 'hidden' : '';
  };
  document.querySelectorAll('[data-open-drawer]').forEach((b) => b.addEventListener('click', () => toggle(true)));
  document.querySelectorAll('[data-close-drawer]').forEach((b) => b.addEventListener('click', () => toggle(false)));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') toggle(false); });

  // Inputs that submit their form on change (country, language, cart qty)
  document.querySelectorAll('[data-autosubmit]').forEach((el) =>
    el.addEventListener('change', () => el.form && el.form.submit()));
  // Filter checkboxes apply immediately
  document.querySelectorAll('[data-autosubmit-form]').forEach((form) =>
    form.addEventListener('change', (e) => { if (e.target.type === 'checkbox') form.requestSubmit(); }));

  // Desktop dropdowns: open under the clicked menu item, close on outside click or Escape
  const tops = [...document.querySelectorAll('.hdr__top')];
  const closeMega = () => tops.forEach((b) => {
    b.setAttribute('aria-expanded', 'false');
    const panel = document.getElementById(b.dataset.mega);
    if (panel) panel.hidden = true;
  });
  tops.forEach((b) => b.addEventListener('click', () => {
    const open = b.getAttribute('aria-expanded') === 'true';
    closeMega();
    if (open) return;
    const panel = document.getElementById(b.dataset.mega);
    panel.style.left = Math.max(0, b.getBoundingClientRect().left - 20) + 'px';
    panel.hidden = false;
    b.setAttribute('aria-expanded', 'true');
  }));
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.hdr__top, .mega')) closeMega();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeMega(); });

  // Product cards: image arrows and colour squares
  document.addEventListener('click', (e) => {
    const arrow = e.target.closest('.card__arrow');
    const swatch = e.target.closest('.card__swatch');
    if (!arrow && !swatch) return;
    e.preventDefault();
    const card = e.target.closest('[data-card]');
    const slides = [...card.querySelectorAll('.card__slide')];
    let idx = slides.findIndex((s) => s.classList.contains('is-active'));
    if (arrow) {
      idx = (idx + Number(arrow.dataset.dir) + slides.length) % slides.length;
      slides.forEach((s, i) => s.classList.toggle('is-active', i === idx));
      const count = card.querySelector('.card__count');
      if (count) count.textContent = `${idx + 1} / ${slides.length}`;
      return;
    }
    card.querySelectorAll('.card__swatch').forEach((s) => s.classList.toggle('is-active', s === swatch));
    if (swatch.dataset.img) {
      const img = slides[0].querySelector('img');
      if (img) { img.removeAttribute('srcset'); img.src = swatch.dataset.img; }
      slides.forEach((s, i) => s.classList.toggle('is-active', i === 0));
      const count = card.querySelector('.card__count');
      if (count) count.textContent = `1 / ${slides.length}`;
    }
  });
  // Product page gallery: one main image, thumbnails underneath
  const showMedia = (id) => {
    const gallery = document.querySelector('.pdp__gallery');
    if (!gallery || !id || !gallery.querySelector(`[data-media-id="${id}"]`)) return;
    gallery.querySelectorAll('[data-media-id]').forEach((m) => m.classList.toggle('is-active', m.dataset.mediaId === String(id)));
    gallery.querySelectorAll('[data-thumb]').forEach((t) => t.classList.toggle('is-active', t.dataset.thumb === String(id)));
  };
  document.addEventListener('click', (e) => {
    const thumb = e.target.closest('[data-thumb]');
    if (thumb) showMedia(thumb.dataset.thumb);
  });
  // Variant picker
  const root = document.querySelector('[data-product]');
  const data = document.querySelector('[data-variants]');
  if (!root || !data) return;
  const variants = JSON.parse(data.textContent);
  const idInput = root.querySelector('[data-variant-id]');
  const price = root.querySelector('[data-price]');
  const add = root.querySelector('[data-add]');
  root.addEventListener('change', (e) => {
    if (!e.target.matches('[data-option]')) return;
    const chosen = [...root.querySelectorAll('[data-option]:checked')].map((i) => i.value);
    root.querySelector(`[data-option-label="${e.target.dataset.option}"]`).textContent = e.target.value;
    const v = variants.find((x) => x.options.every((o, i) => o === chosen[i]));
    if (!v) { add.disabled = true; add.textContent = 'Unavailable'; return; }
    idInput.value = v.id;
    price.textContent = v.price;
        showMedia(v.media);
    add.disabled = !v.available;
    add.textContent = v.available ? 'Add to Bag' : 'Sold Out';
    const url = new URL(location.href);
    url.searchParams.set('variant', v.id);
    history.replaceState(null, '', url);
  });
})();
// Homepage: give the see-through header a white background once the page scrolls (or a dropdown/menu is open)
(() => {
  const bar = document.querySelector('.template-index .hdr-section');
  if (!bar) return;
        const hero = document.querySelector('.hero');
  const update = () => bar.classList.toggle('is-solid',
    hero ? hero.getBoundingClientRect().bottom <= bar.offsetHeight : window.scrollY > 10);
  window.addEventListener('scroll', update, { passive: true });
  document.addEventListener('click', () => setTimeout(update, 0));
  update();
})();
// Search panel: open from the header's Search link/icon, close with ×, Escape or a click outside
(() => {
  const panel = document.getElementById('search-panel');
  if (!panel) return;
  const input = panel.querySelector('[data-search-input]');
  const close = () => { panel.hidden = true; };
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-search-open]')) {
      e.preventDefault();
      panel.hidden = !panel.hidden;
      if (!panel.hidden) input.focus();
    } else if (e.target.closest('[data-search-close]') || !e.target.closest('#search-panel')) {
      close();
    }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
})();
// Bag side panel: open from the header, add-to-bag without leaving the page, change quantities in place
(() => {
  const drawer = document.getElementById('cart-drawer');
  if (!drawer) return;
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const open = () => { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; };
  const close = () => { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; };

  // Re-render the panel and the "Bag (n)" counts from a fresh copy of the cart page
  const refresh = async () => {
    const html = await fetch(root + 'cart', { cache: 'no-store' }).then((r) => r.text());
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('#cart-drawer .cd__panel');
    if (fresh) drawer.querySelector('.cd__panel').innerHTML = fresh.innerHTML;
    const counts = doc.querySelectorAll('[data-cart-count]');
    document.querySelectorAll('[data-cart-count]').forEach((el, i) => { if (counts[i]) el.textContent = counts[i].textContent; });
  };

  document.addEventListener('click', async (e) => {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-cart-close]')) { close(); return; }
    const line = e.target.closest('[data-cart-line]');
    if (line) {
      const panel = drawer.querySelector('.cd__panel');
      panel.classList.add('cd__busy');
      try {
        await fetch(root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: Number(line.dataset.cartLine), quantity: Math.max(0, Number(line.dataset.qty)) })
        });
        await refresh();
      } finally { panel.classList.remove('cd__busy'); }
    }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });

  // Product page "Add to Bag": add in the background, then slide the bag open
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    let err = form.querySelector('.pdp__error');
    if (err) err.remove();
    if (btn) btn.disabled = true;
    try {
      const res = await fetch(root + 'cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        err = document.createElement('p');
        err.className = 'pdp__error';
        err.textContent = data.description || 'This item could not be added to your bag.';
        form.appendChild(err);
        return;
      }
      await refresh();
      open();
    } finally { if (btn) btn.disabled = false; }
  });
})();